export const IS_LOGIN = 'IS_LOGIN';
export const USER_INFO = 'USER_INFO';
export const Language = 'Language';


// WEBPACK FOOTER //
// ./public/constants/ActionTypes.js